export interface MeetingParticipant {
  name: string;
  email: string | null;
}
export interface TranscriptSegment {
  speaker: string;
  timestamp: string;
  text: string;
}
/** A live project tagged on a meeting. Never carries meeting content. */
export interface MeetingProjectRef {
  id: string;
  name: string;
}
/** A meeting as shown on a project page: no summary or transcript fields. */
export interface ProjectMeetingItem {
  id: string;
  title: string;
  recorded_at: number;
  duration_seconds: number | null;
}
export interface MeetingListItem {
  id: string;
  title: string;
  recording_url: string | null;
  recorded_at: number;
  duration_seconds: number | null;
  participants: MeetingParticipant[];
  excerpt: string;
  summary_ready: boolean;
  transcript_ready: boolean;
  source_fetched_at: number;
  /** Tagged live projects, sorted by name. */
  projects: MeetingProjectRef[];
}
export interface MeetingDetail extends MeetingListItem {
  summary_markdown: string | null;
  transcript: TranscriptSegment[] | null;
  summary_fetched_at: number | null;
  transcript_fetched_at: number | null;
}
export interface MeetingSyncStatus {
  library_revision: number;
  state: "disconnected" | "idle" | "importing" | "syncing" | "failed";
  processed: number;
  last_sync_at: number | null;
  last_provider_success_at: number | null;
  retry_at: number | null;
  error_code: string | null;
}
export interface MeetingsResponse {
  meetings: MeetingListItem[];
  total: number;
  page: number;
  page_size: number;
}
/** Only API-provided recording pages on these exact hosts may be opened. */
export function fathomRecordingUrl(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 2048) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" &&
      ["fathom.video", "www.fathom.video"].includes(url.hostname) &&
      !url.username &&
      !url.password &&
      !url.port &&
      url.pathname !== "/"
      ? url.href
      : null;
  } catch {
    return null;
  }
}
export function transcriptSourceText(segments: TranscriptSegment[]): string {
  return segments
    .map((s) => `${s.timestamp} ${s.speaker}\n${s.text}`)
    .join("\n\n");
}
